import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Rating, IconButton } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { fetchGoogleReviewsWithCache } from "../utils/getGoogleData";


import { useMediaQuery } from "@mui/material";
import theme from "../theme";

const Container = styled.div`
  width: calc(100% - 2rem);
  padding: 0rem 1rem;
  max-width: 1200px;
  margin: auto;
  position: relative;
  overflow: hidden;
`;

const AvisWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

const ArrowButton = styled(IconButton)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: transparent;
  color: #333;
  z-index: 10;
  border-radius: 50%;
  padding: 0.5rem;

  &:hover {
    background-color: transparent;
  }

  ${({ disabled }) =>
    disabled &&
    `
    color: #ccc;
    pointer-events: none;
  `}
`;

const LeftArrow = styled(ArrowButton)`
  left: -0.5rem;
  padding: 0px !important;
`;

const RightArrow = styled(ArrowButton)`
  right: -0.5rem;
  padding:0px;
  padding:0px !important;
`;

const AvisViewport = styled.div`
  width: 100%;
  overflow: hidden;
`;

const AvisList = styled.div`
  display: flex;
  gap: 1rem;
  padding: 1rem;

  ${theme.breakpoints.down("sm")} {
    padding: 0rem;
  } 
`;

const AvisCard = styled.div`
  flex: 1;
  padding: 1rem;
  border-radius: 16px;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  font-family: "Montserrat", sans-serif;
  ${theme.breakpoints.down("sm")} {
    padding: 0.5rem;
  } 
`;

const AvisHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Comment = styled.p`
  margin: 1rem 0;
  display: -webkit-box;
  -webkit-line-clamp: ${({ expanded }) => (expanded ? "none" : 4)};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;

const Name = styled.div`
  font-weight: bold;
  margin-top: auto;
`;

const DateText = styled.div`
  font-size: 0.6rem;
  color: #666;
`;

const AvisGoogle = () => {
  const [startIndex, setStartIndex] = useState(0);
  const [expandedIndex, setExpandedIndex] = useState(null);

  const [avis, setAvis] = useState([]);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const itemsPerPage = isSmallScreen ? 1 : 3;

  useEffect(() => {

    const loadReviews = async () => {
      const data = await fetchGoogleReviewsWithCache();
      if (!data) return;

      const sortedReviews = data.reviews.sort((a, b) => new Date(b.publishDateTime) - new Date(a.publishDateTime));

      // We keep only reviews with a rating greater than 3
      const filteredReviews = sortedReviews.filter(review => review.starRating > 3);
      setAvis(filteredReviews);
       console.log(data);
      //setRating(data.globalRating);
    };
    loadReviews();
  }, []);

  const handleNext = () => {
    if (startIndex + itemsPerPage < avis.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const handleBack = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  const translateX = -(startIndex * (100 / itemsPerPage));

  return (
    <Container>
      <AvisWrapper>
        <LeftArrow onClick={handleBack} disabled={startIndex === 0}>
          <ChevronLeftIcon fontSize="large" />
        </LeftArrow>

        <AvisViewport>
        < AvisList >
          {avis.slice(startIndex, startIndex + itemsPerPage).map((review, i) => (
            <AvisCard key={i}>
              <AvisHeader>
                <Rating
                  style={{ fontSize: "1.2rem" }}
                  name="read-only"
                  value={review.starRating}
                  precision={0.5}
                  readOnly
                />
                <DateText>{review.updateTime}</DateText>
              </AvisHeader>
              <Comment
                expanded={expandedIndex === i}
                onClick={() =>
                  setExpandedIndex(expandedIndex === i ? null : i)
                }>
                {review.comment?.text || review?.comment}
              </Comment>
              <Name>{review?.reviewer || "Anonyme"}</Name>
            </AvisCard>
          ))}
        </AvisList>
        </AvisViewport>

        <RightArrow
          onClick={handleNext}
          disabled={startIndex + itemsPerPage >= avis.length}>
          <ChevronRightIcon fontSize="large" />
        </RightArrow>
      </AvisWrapper>
    </Container>
  );
};

export default AvisGoogle;
